import type { INotificationRepository, NotificationSearchOptions } from '../repositories/INotificationRepository.js';
import type { NotificationEntity } from '../entities/NotificationEntity.js';

interface Deps { notificationRepository: INotificationRepository; }

export function createSearchNotificationsUseCase({ notificationRepository }: Deps) {
  return function searchNotifications(options: NotificationSearchOptions): Promise<NotificationEntity[]> {
    return notificationRepository.search(options);
  };
}
